var _style, _path, _g, _g2, _g3, _g4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTrainingPi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 94 94",
    style: {
      enableBackground: "new 0 0 94 94"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#0071B9;}\n\t.st1{fill:#F5FAFC;}\n\t.st2{fill:none;stroke:#0071B9;stroke-width:3;}\n\t.st3{fill:#0071B9;}\n\t.st4{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_74",
    className: "st0",
    d: "M-98.7,40.2v-4.3h8V60h-4.8V40.2H-98.7z M-84.7,54.8c2.1-1.8,3.8-3.2,5-4.4 c1.2-1.1,2.2-2.3,3.1-3.7c0.8-1.1,1.2-2.4,1.3-3.8c0.1-0.9-0.2-1.9-0.8-2.6c-0.6-0.7-1.5-1-2.4-1c-1-0.1-1.9,0.4-2.5,1.1 c-0.6,0.9-1,1.9-0.9,3h-4.5c-0.1-2.2,0.8-4.4,2.4-6c1.6-1.4,3.6-2.1,5.7-2c2.1-0.1,4.2,0.6,5.8,2c1.4,1.4,2.1,3.3,2,5.3 c0,1.7-0.5,3.4-1.4,4.9s-1.9,2.9-3.2,4.1c-1.2,1.2-2.7,2.5-4.7,4.2h9.7v3.8h-16.3v-3.4L-84.7,54.8z M-67.2,42.3c0-2,0.8-3.8,2.3-5.1 c1.6-1.3,3.6-1.9,5.7-1.8c1.4,0,2.8,0.2,4.1,0.8c1.1,0.5,2,1.3,2.6,2.3s0.9,2.1,0.9,3.3c0,1.3-0.3,2.5-1.1,3.5 c-0.6,0.9-1.5,1.6-2.6,1.9v0.1c1.2,0.3,2.3,1.1,3,2.1c0.8,1.2,1.1,2.5,1.1,3.9c0,1.2-0.3,2.5-0.9,3.5c-0.6,1.1-1.6,1.9-2.7,2.4 c-1.3,0.6-2.8,0.9-4.2,0.9c-2.2,0.1-4.3-0.6-6.1-1.9c-1.6-1.4-2.5-3.4-2.5-5.5h4.5c0,1,0.4,1.9,1.1,2.6c0.8,0.7,1.8,1,2.9,1 c1,0.1,1.9-0.3,2.6-0.9c0.6-0.7,0.9-1.5,0.9-2.4c0.1-1.1-0.4-2.2-1.3-2.8c-1.2-0.7-2.5-1-3.9-0.9h-1v-3.8h1c3.1,0,4.7-1,4.7-3.1 c0-0.8-0.3-1.6-0.8-2.2c-0.7-0.6-1.5-0.9-2.4-0.8c-0.9-0.1-1.7,0.2-2.4,0.8c-0.6,0.6-0.9,1.3-1,2.1L-67.2,42.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_15_00000057147396975116190640000002754196461170988210_",
    transform: "translate(777.224 173.42)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -730.2,
    cy: -126.4,
    r: 47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -730.2,
    cy: -126.4,
    r: 45.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.4,38.9v-4.5h24.4v4.5H34.4z M38.3,59.4v-25h5v24.9L38.3,59.4L38.3,59.4z M55.7,59.8c-2.3,0-4-0.6-5-1.8 s-1.5-3.2-1.5-5.9V34.4h5v17.4c0,1.2,0.2,2.1,0.6,2.7c0.4,0.6,1.2,0.8,2.4,0.8c0.2,0,0.4,0,0.7,0c0.2,0,0.5-0.1,0.8-0.1l0.6,4.4 c-0.6,0.1-1.1,0.2-1.6,0.2C57.1,59.8,56.5,59.8,55.7,59.8z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon_training_number_00000146480558143541647720000010573209375286762685_",
    transform: "translate(-777.224 -173.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_15_00000046301946818682061130000007132517913311474586_",
    transform: "translate(777.224 173.42)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -84,
    cy: 47,
    r: 47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -84,
    cy: 47,
    r: 45.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_74_00000138552609984836695580000009700472106708316344_",
    className: "st3",
    d: "M669.1,213.6v-4.3h8v24.1h-4.8v-19.8 H669.1z M683.1,228.2c2.1-1.8,3.8-3.2,5-4.4c1.2-1.1,2.2-2.3,3.1-3.7c0.8-1.1,1.2-2.4,1.3-3.8c0.1-0.9-0.2-1.9-0.8-2.6 c-0.6-0.7-1.5-1-2.4-1c-1-0.1-1.9,0.4-2.5,1.1c-0.6,0.9-1,1.9-0.9,3h-4.5c-0.1-2.2,0.8-4.4,2.4-6c1.6-1.4,3.6-2.1,5.7-2 c2.1-0.1,4.2,0.6,5.8,2c1.4,1.4,2.1,3.3,2,5.3c0,1.7-0.5,3.4-1.4,4.9s-1.9,2.9-3.2,4.1c-1.2,1.2-2.7,2.5-4.7,4.2h9.7v3.8h-16.3 v-3.4L683.1,228.2z M700.6,215.7c0-2,0.8-3.8,2.3-5.1c1.6-1.3,3.6-1.9,5.7-1.8c1.4,0,2.8,0.2,4.1,0.8c1.1,0.5,2,1.3,2.6,2.3 s0.9,2.1,0.9,3.3c0,1.3-0.3,2.5-1.1,3.5c-0.6,0.9-1.5,1.6-2.6,1.9v0.1c1.2,0.3,2.3,1.1,3,2.1c0.8,1.2,1.1,2.5,1.1,3.9 c0,1.2-0.3,2.5-0.9,3.5c-0.6,1.1-1.6,1.9-2.7,2.4c-1.3,0.6-2.8,0.9-4.2,0.9c-2.2,0.1-4.3-0.6-6.1-1.9c-1.6-1.4-2.5-3.4-2.5-5.5h4.5 c0,1,0.4,1.9,1.1,2.6c0.8,0.7,1.8,1,2.9,1c1,0.1,1.9-0.3,2.6-0.9c0.6-0.7,0.9-1.5,0.9-2.4c0.1-1.1-0.4-2.2-1.3-2.8 c-1.2-0.7-2.5-1-3.9-0.9h-1v-3.8h1c3.1,0,4.7-1,4.7-3.1c0-0.8-0.3-1.6-0.8-2.2c-0.7-0.6-1.5-0.9-2.4-0.8c-0.9-0.1-1.7,0.2-2.4,0.8 c-0.6,0.6-0.9,1.3-1,2.1L700.6,215.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icon_training_number_00000121274477977407183480000008900058464857538977_",
    transform: "translate(-777.224 -173.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_15_00000133500740783798659210000012796061996622103707_",
    transform: "translate(777.224 173.42)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 172.1,
    cy: 47.9,
    r: 47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 172.1,
    cy: 47.9,
    r: 45.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M172.1,69.7c-3.1,0-5.9-0.5-8.5-1.7c-2.7-1.1-5-2.7-6.9-4.7c-1.9-1.9-3.6-4.3-4.7-6.9 c-1.1-2.7-1.7-5.5-1.7-8.5s0.5-5.9,1.7-8.5c1.1-2.7,2.7-5,4.7-6.9c1.9-1.9,4.3-3.6,6.9-4.7c2.7-1.1,5.5-1.7,8.5-1.7 s5.9,0.5,8.5,1.7c2.7,1.1,5,2.7,6.9,4.7c1.9,1.9,3.6,4.3,4.7,6.9c1.1,2.5,1.7,5.5,1.7,8.5s-0.5,5.9-1.7,8.5 c-1.1,2.7-2.7,5-4.7,6.9c-1.9,1.9-4.3,3.6-6.9,4.7C178,69.1,175,69.7,172.1,69.7z M169.9,65.2V61c-1.1,0-2.2-0.4-3.1-1.3 s-1.3-1.9-1.3-3.1v-2.3L155.2,44c-0.1,0.6-0.3,1.3-0.3,1.9c-0.1,0.6-0.1,1.3-0.1,1.9c0,4.5,1.4,8.3,4.3,11.6 C161.8,62.7,165.5,64.6,169.9,65.2z M185,59.6c0.8-0.8,1.4-1.7,1.9-2.5c0.6-0.9,1-1.9,1.4-2.9c0.4-1,0.6-2,0.9-3.1 s0.3-2.2,0.3-3.2c0-3.6-1-6.8-2.9-9.8c-2-2.9-4.6-5.1-7.9-6.4v0.9c0,1.1-0.4,2.2-1.3,3.1c-0.9,0.9-1.9,1.3-3.1,1.3h-4.3v4.3 c0,0.6-0.3,1.1-0.6,1.5c-0.4,0.4-0.9,0.6-1.5,0.6h-4.3v4.3h13.1c0.6,0,1.1,0.3,1.5,0.6c0.4,0.4,0.6,0.9,0.6,1.5v6.5h2.2 c0.9,0,1.8,0.3,2.5,0.9C184.1,58,184.6,58.7,185,59.6z"
  })))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.64,
      enableBackground: "new"
    },
    width: 1556,
    height: 574,
    xlinkHref: "../../../Desktop/\\u2605\\u30B9\\u30AF\\u30EA\\u30FC\\u30F3\\u30B7\\u30E7\\u30C3\\u30C8/\\u30B9\\u30AF\\u30EA\\u30FC\\u30F3\\u30B7\\u30E7\\u30C3\\u30C8 2023-12-10 18.45.59.png",
    transform: "matrix(0.5186 0 0 0.5186 -180.358 -402.5568)"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icon_training_number_00000065054870888877929970000013717806189246345896_",
    transform: "translate(-777.224 -173.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_15_00000060746008010457037290000008627949417840844433_",
    transform: "translate(777.224 173.42)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 294.4,
    cy: 50.8,
    r: 47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 294.4,
    cy: 50.8,
    r: 45.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M293.8,73.4c-3.1,0-6.1-0.6-8.8-1.8c-2.7-1.2-5.1-2.8-7.2-4.8c-2-2-3.6-4.4-4.8-7.2c-1.2-2.7-1.8-5.7-1.8-8.8 s0.6-6.1,1.8-8.8s2.8-5.1,4.8-7.2c2-2,4.4-3.6,7.2-4.8c2.7-1.2,5.7-1.8,8.8-1.8c5.5,0,10.3,1.7,14.4,5.2s6.7,7.8,7.7,13h-4.6 c-0.7-2.7-2-5.2-3.9-7.4s-4.2-3.8-6.9-4.9V35c0,1.2-0.4,2.3-1.3,3.2s-1.9,1.3-3.2,1.3h-4.5V44c0,0.6-0.2,1.2-0.6,1.6 c-0.4,0.4-1,0.6-1.6,0.6h-4.5v4.5h4.5v6.8H287l-10.8-10.8c-0.1,0.7-0.2,1.4-0.3,2c-0.1,0.7-0.1,1.4-0.1,2c0,4.9,1.7,9.2,5.2,12.7 c3.5,3.5,7.8,5.3,12.9,5.4v4.6C293.9,73.4,293.8,73.4,293.8,73.4z M314.4,72.2l-7.2-7.2c-0.8,0.5-1.6,0.8-2.5,1.1 c-0.9,0.3-1.9,0.5-2.9,0.5c-2.8,0-5.2-1-7.2-3s-3-4.4-3-7.2s1-5.2,3-7.2s4.4-3,7.2-3s5.2,1,7.2,3s3,4.4,3,7.2c0,1-0.2,2-0.5,2.9 s-0.7,1.8-1.1,2.5l7.2,7.2L314.4,72.2z M301.7,62.1c1.6,0,2.9-0.5,4-1.6s1.6-2.4,1.6-4s-0.5-2.9-1.6-4s-2.4-1.6-4-1.6 s-2.9,0.5-4,1.6s-1.6,2.4-1.6,4s0.5,2.9,1.6,4C298.8,61.5,300.1,62.1,301.7,62.1z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -151,
    y: 201,
    className: "st4",
    width: 0,
    height: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrainingPi);
export default __webpack_public_path__ + "static/media/icon_training_pi.02264a5bb234aed0d9b471cb92bc7610.svg";
export { ForwardRef as ReactComponent };